<template>
  <div class="hero-banner" :style="bannerStyle">
    <div class="hero-banner__content">
      <h2 v-if="title" class="hero-banner__title" v-html="title"></h2>
      <p v-if="subTitle" class="hero-banner__sub-title" v-html="subTitle"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroBanner',
  props: {
    backgroundImage: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    bannerStyle() {
      if (this.backgroundImage && this.backgroundImage.length > 0) {
        const img1x = this.backgroundImage[0];
        const img2x = this.backgroundImage[1];

        // 2x 이미지가 있으면 image-set 사용, 없으면 1x만 사용
        if (img2x) {
          return {
            backgroundImage: `-webkit-image-set(url(${img1x}) 1x, url(${img2x}) 2x)`,
            backgroundImage: `image-set(url(${img1x}) 1x, url(${img2x}) 2x)`
          };
        } else {
          return {
            backgroundImage: `url(${img1x})`
          };
        }
      }
      return {};
    }
  },
  data() {
    return {};
  },
  mounted() {
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.hero-banner {
  height: 670px;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    //background: rgba(0, 0, 0, 0.3);
  }

  &__content {
    position: relative;
    z-index: 1;
    text-align: center;
    padding: 0 20px;
  }
  &__title {
    font-weight:600;
    font-size: 44.64px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: -1.34px;
    text-align: center;
    vertical-align: middle;
    color: #fff;
    margin: 0 0 20px;
  }

  &__sub-title {
    font-weight: 350;
    font-style: DemiLight;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 30px;
    letter-spacing: -4%;
    text-align: center;
    color: #fff;
    margin: 0;
    line-height: 1.5;
  }

  @media (max-width: 768px) {
    height: 400px;

    &__title {
      font-size: 32px;
      margin-bottom: 12px;
    }

    &__sub-title {
      font-size: 16px;
    }
  }
}
</style>